import { routes } from 'app/routing/routesConfig';
import { useIsMobile } from 'app/utils/hooks';
import { FC, useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProfileDesktop } from './ProfileDesktop';
import { ProfileMobile } from './ProfileMobile';

export const Profile: FC = () => {
  const isMobile = useIsMobile();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (isMobile && pathname.includes(routes.profileBasic.path)) {
      navigate(routes.profile.path);
    }
  }, [isMobile, navigate, pathname]);

  return isMobile ? <ProfileMobile /> : <ProfileDesktop />;
};
